// extracted by mini-css-extract-plugin
module.exports = {"text":"propertyDeveloper_text__2BDS4","link":"propertyDeveloper_link__1pVG2"};
    if(module.hot) {
      // 1790670313270
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  